/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_5_TitleInputs */

const en_gc_search_guides_gridcraft_online_sections_5_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep browser downloads easy to identify`)
};

const zh_gc_search_guides_gridcraft_online_sections_5_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让浏览器下载的文件容易辨认`)
};

/**
* | output |
* | --- |
* | "Keep browser downloads easy to identify" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_5_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_5_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_5_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_5_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_5_title(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_5_title(inputs)
});
export { gc_search_guides_gridcraft_online_sections_5_title as "gc.search_guides.gridcraft_online.sections.5.title" }